import axios from "axios";

const otpApi = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const OtpApi = {
  requestWhatsapp: (phone: string) =>
    otpApi.post<{ status: string }>("/auth/otp/request", { phone }),

  verifyWhatsapp: (phone: string, code: string) =>
    otpApi.post<{ token: string }>("/auth/otp/verify", { phone, code }),

  requestEmail: (email: string) =>
    otpApi.post<{ status: string }>("/auth/otp/email/request", { email }),

  verifyEmail: (email: string, code: string) =>
    otpApi.post<{ token: string }>("/auth/otp/email/verify", { email, code }),
};
